<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCSVGraph()" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="enrollChartData && enrollChartData.dataset && enrollChartData.dataset.length > 0">
    <div class="card-text-strong d-inline" slot="header">
      <span class="float-right enrol-tabs">
        <b-tabs v-model="tabIndex">
          <b-tab :title="`Total`" @click="changeTab('total')"> </b-tab>
          <b-tab :title="`Countries`" @click="changeTab('country')"> </b-tab>
          <b-tab v-if="specificSiteId && specificSiteId && specificSiteId.length === 0" :title="`Sites`" @click="changeTab('site')"> </b-tab>
        </b-tabs>
      </span>
    </div>
    <div v-if="enrollChartData && enrollChartData.dataset && enrollChartData.dataset.length > 0" class="row" slot="body">
      <fusioncharts v-bind:class="{ 'fusion-line-chart': tabIndex !== 0 }" :style="tabIndex === 0 ? 'width: calc(100% - 115px);' : 'width: 100%'" :type="type" width="100%" :height="height" :dataFormat="dataFormat" :dataSource="enrollChartData" dataEmptyMessage="No Data In" ref="timeActiveStatusPercentage" />

      <div class="d-flex flex-column justify-content-center p-0" v-if="tabIndex === 0">
        <div>
          <span id="monthlyAverage" class="study-completion-legend-upcoming study-completion-tooltip"> </span>
          <span class="study-completion-legend-text">Monthly Average</span>
        </div>
        <div>
          <span id="monthlyMaxMin" class="study-completion-legend-complete study-completion-tooltip"> </span>
          <span class="study-completion-legend-text">Monthly Min/Max</span>
        </div>
      </div>
    </div>
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
    <div slot="body" class="text-left min-height-0" v-if="enrollChartData && enrollChartData.dataset && enrollChartData.dataset.length > 0">
      <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
        <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
      </span>
      <span @click="zoomInChart()" class="remove-zoom-icons">
        <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
      </span>
    </div>
  </chart-container>
</template>
<script>
import moment from "moment";
import _get from "lodash/get";
import _ from "lodash";
import { fusionChartCommon, lineColor, durationOfTelehealthVisitsTooltip } from "../../services/visualization/recruitment";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "@/components/containers/chart-container";

function convertMonthToTimestamps(month) {
  const format = month.includes("-") ? "YYYY-MM-DD" : "MMM YYYY";
  if (!month || typeof month !== "string") {
    return;
  }
  return new Date(moment.utc(month, format)).getTime();
}

export default {
  components: { ChartContainer },
  props: {
    rawData: { type: Object, default: () => {} },
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    monthSelected: [Object, Array],
    countryList: [Object, Array],
    allSitesList: [Object, Array],
    fromDate: [Object, String],
    toDate: [Object, String],
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String },
    specificSiteId: [Object, Array],
    dataLoaded: { type: Boolean, default: false },
    showTotalParticipant: { type: Boolean, default: true },
    xyAxisValue: [Object, String],
    tabs: { type: [Object, Array], default: () => ["Total", "Countries"] }
  },
  data() {
    return {
      downloadId: "study-enrollment-progress",
      studyId: null,
      zoomGraphValueChild: "",
      tabIndex: 0,
      height: "250",
      enrollChartData: null,
      enrollTab: "total",
      avgUnitTimeByMonthInStudies: null,
      totalUnitTimeByMonthInStudies: null,
      avgUnitTimeByMonthInCountries: null,
      initializeWeeks: null,
      getSiteID,
      dataFormat: "json",
      type: "errorline",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      isDataConverted: false,//set true when TH Visit duration data is converted from sec to mins
    };
  },
  watch: {
    rawData() {
      if (Object.keys(this.rawData).length == 0) {
        this.enrollChartData.dataset = [];
        return;
      }
      this.avgUnitTimeByMonthInStudies = _.cloneDeep(this.rawData.avgUnitTimeByMonthInStudies);
      const cloneForTotal = _.cloneDeep(this.rawData.avgUnitTimeByMonthInStudies);
      // Set Total monthlyWise
      this.totalUnitTimeByMonthInStudies = cloneForTotal.map(iw => {
        iw.y = iw.y2;
        return iw;
      });

      // Set the avg unit tine base on country
      this.avgUnitTimeByMonthInCountries = _.cloneDeep(this.rawData.avgUnitTimeByMonthInCountries);
      this.initializeWeeks = this.avgUnitTimeByMonthInStudies.map(iw => iw.x);
      this.locations = _.cloneDeep(_get(this.rawData, "locations", null));
      
      if(this.isDataConverted === false){
        this.convertSecondsToMin();
      }
    },
    countrySelected() {
      this.generateEnrollData();
    },
    sitesSelected() {
      this.generateEnrollData();
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    enrollTab: function(newVal) {
      this.tabIndex = newVal === "total" ? 0 : newVal === "country" ? 1 : 2;
    },
    monthSelected: function() {
      if (this.avgUnitTimeByMonthInCountries && this.totalUnitTimeByMonthInStudies) {
        this.generateEnrollData();
      }
    }
  },
  methods: {
    downloadCSVGraph() {
      const csvHeaders = this.generateCsvHeaders(this.tabIndex);
      const dataForCSV = [];

      this.enrollChartData.dataset.map((row, i) => {
        row.data.map((rowLine, j) => {
          let value = rowLine.value < 1 ? (Math.round(rowLine.value * 100)/100) : Math.round(rowLine.value);
          if (!dataForCSV[j]) {
            dataForCSV[j] = [];
            if (this.tabIndex === 0) {
              let min = rowLine.ymin < 1 ? (Math.round(rowLine.ymin * 100)/100) : Math.round(rowLine.ymin);
              let max = rowLine.ymax < 1 ? (Math.round(rowLine.ymax * 100)/100) : Math.round(rowLine.ymax);
              dataForCSV[j].push(this.enrollChartData.categories[i].category[j].label.toUpperCase(), value, min, max);
            } else {
              dataForCSV[j].push(this.enrollChartData.categories[i].category[j].label.toUpperCase(), value);
            }
          } else {
            dataForCSV[j].push(value);
          }
        });
      });
      downloadCSV(this.titleChart, csvHeaders, dataForCSV, this.specificSiteId);
    },
    generateCsvHeaders(tabIndexCancelledTelehealthVisits) {
      let headers = [];
      switch (tabIndexCancelledTelehealthVisits) {
        case 0:
          headers = ["Total", "Monthly Average(Minutes)", "Min(Minutes)", "Max(Minutes)"];
          break;
        case 1:
          headers = ["Countries"];
          this.enrollChartData.dataset.map(row => {
            headers.push(row.seriesname + "(Minutes)");
          });
          break;
        case 2:
          headers = ["Sites"];
          this.enrollChartData.dataset.map(row => {
            headers.push(row.seriesname + "(Minutes)");
          });
          break;
        default:
          break;
      }

      return headers;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = 0;
          break;
        case 1:
          numVisPlot = Math.round(0.75 * this.maxColumn);
          break;
        case 2:
          numVisPlot = Math.round(0.5 * this.maxColumn);
          break;
        case 3:
          numVisPlot = Math.round(0.2 * this.maxColumn);
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    getPlotToolText() {
      const participantToolTextWithLabel = `<div id="toolTextParticipant">
          <span class="label-top"><b>$label</b></span>
          <span class="data-label-text">$dataValue mins <b>$seriesName</b></span>
      </div>`;
      return participantToolTextWithLabel;
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.timeActiveStatusPercentage.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    changeTab(tab) {
      if (Object.keys(this.rawData).length == 0) {
        this.enrollChartData.dataset = [];
        return;
      }
      this.enrollTab = tab;
      this.type = tab === "total" ? "errorline" : "scrollline2d";
      this.generateEnrollData();
    },
    generateDataVisualizationForChart(baseWeekLables = [], dataObject = [], choosenMonth = []) {
      const returnData = [];
      const weekLabelKeys = dataObject.map(dbj => dbj.x);

      const firstMonth = typeof choosenMonth[0] === "number" ? choosenMonth[0] : convertMonthToTimestamps(choosenMonth[0]);
      const lastMonth = typeof choosenMonth[1] === "number" ? choosenMonth[1] : convertMonthToTimestamps(choosenMonth[1]);

      for (let i = 0; i < baseWeekLables.length; i++) {
        const x = baseWeekLables[i];
        const thisMonth = convertMonthToTimestamps(x);

        if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
          if (weekLabelKeys.includes(x)) {
            const indexDataObject = dataObject.findIndex(ido => ido.x === x);
            const y = dataObject[indexDataObject].y < 1 ? (Math.round(dataObject[indexDataObject].y * 100)/100) : Math.round(dataObject[indexDataObject].y);
            returnData.push({
              value: y,
              index: i,
              x: x
            });
          } else {
            returnData.push({
              value: 0,
              index: i,
              x: x
            });
          }
        }
      }
      return returnData;
    },
    generateEnrollData() {
      let dataForVisualizations = this.setVisualization(this.countrySelected, this.sitesSelected, this.monthSelected);
      if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0)) {
        dataForVisualizations = [];
      } else {
        dataForVisualizations = _.filter(dataForVisualizations, dataForVisualization => {
          return dataForVisualization.filterType === this.enrollTab || dataForVisualization.filterType === "all";
        });
      }
      /* =============================================== */
      // Get date label for chart base on selected month //
      /* =============================================== */
      const firstMonth = typeof this.monthSelected[0] === "number" ? this.monthSelected[0] : typeof this.monthSelected[0] === "string" ? convertMonthToTimestamps(this.monthSelected[0]) : convertMonthToTimestamps(this.monthSelected[0].display);
      const lastMonth = typeof this.monthSelected[1] === "number" ? this.monthSelected[0] : typeof this.monthSelected[1] === "string" ? convertMonthToTimestamps(this.monthSelected[1]) : convertMonthToTimestamps(this.monthSelected[1].display);
      const categories = [];
      this.initializeWeeks = this.initializeWeeks || [];
      for (const item of this.initializeWeeks) {
        const thisMonth = convertMonthToTimestamps(item);
        if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
          categories.push({ label: item.toUpperCase() });
        }
      }

      // Update chart
      if (this.enrollTab === "total") {
        let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
        primaryColor = primaryColor || "#00C3B3";
        this.enrollChartData = {
          chart: {
            ...fusionChartCommon,
            paletteColors: lineColor().join(","),
            errorBarColor: primaryColor,
            errorBarThickness: "20",
            errorBarWidth: 30,
            showLegend: "0",
            toolTipColor: "#ffffff",
            decimals: "2"
          },
          categories: [{ category: categories }],
          dataset: dataForVisualizations
        };
        if (this.$refs.timeActiveStatusPercentage) {
          this.$refs.timeActiveStatusPercentage.chartObj.setChartAttribute("showLegend", 0);
        }
      } else {
        this.enrollChartData = {
          chart: {
            ...fusionChartCommon,
            paletteColors: lineColor().join(","),
            canvasBottomPadding: 10,
            canvasTopPadding: 10,
            showLegend: "1",
            decimals: "2"
          },
          categories: [{ category: categories }],
          dataset: dataForVisualizations
        };
        if (this.$refs.timeActiveStatusPercentage) {
          this.$refs.timeActiveStatusPercentage.chartObj.setChartAttribute("showLegend", 1);
        }
      }
      this.maxColumn = categories.length;
    },
    setVisualization(choosenCountries = "all", choosenSites = ["all"], choosenMonth = []) {
      let dataVisualization = [];
      let setAverageLines = [];
      let numParticipantSites = null;
      const allAverage = [];
      const allTotal = [];

      const firstMonth = convertMonthToTimestamps(typeof choosenMonth[0] === "string" ? choosenMonth[0] : choosenMonth[0].value);
      const lastMonth = convertMonthToTimestamps(typeof choosenMonth[0] === "string" ? choosenMonth[1] : choosenMonth[1].value);

      /* ============================================ */
      // Get All Average data base on month selection //
      /* ============================================ */

      if (this.avgUnitTimeByMonthInStudies) {
        for (const item of this.avgUnitTimeByMonthInStudies) {
          const thisMonth = convertMonthToTimestamps(item.x);
          if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
            if (this.enrollTab !== "total") {
              allAverage.push({
                value: item.y,
                dashed: "1",
                color: "#c4c4c4",
                // toolText: durationOfTelehealthVisitsTooltip(this.enrollTab, {x: item.x, y: item.y}),
                anchorBgColor: "#c4c4c4",
                anchorBorderColor: "#c4c4c4"
              });
            } else {
              allAverage.push({
                value: item.y,
                positiveErrorValue: item.ymax - item.y,
                negativeErrorValue: item.y - item.ymin,
                ymax: item.ymax,
                ymin: item.ymin,
                toolText: durationOfTelehealthVisitsTooltip(this.enrollTab, {
                  x: item.x,
                  y: item.y,
                  min: item.ymin,
                  max: item.ymax
                }),
                color: "#c4c4c4",
                anchorBgColor: "#c4c4c4",
                anchorBorderColor: "#c4c4c4",
                dashed: 1
              });
            }
          }
        }
      }
      if (this.totalUnitTimeByMonthInStudies) {
        for (const item of this.totalUnitTimeByMonthInStudies) {
          let totalByMonth = {};
          const thisMonth = convertMonthToTimestamps(item.x);
          if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
            totalByMonth = item;
            allTotal.push(totalByMonth);
          }
        }
      }
      allAverage.forEach(data => {
        data.value = data.value < 1 ? (Math.round(data.value * 100)/100) : Math.round(data.value);
      })
      // Generate all averages!
      const monthlyAverageArray = {
        seriesname: `Monthly Average`,
        data: allAverage,
        filterType: "all",
        plottooltext: this.getPlotToolText(true)
      };

      const countries = this.locations ? Object.keys(this.locations) : [];
      let countryIndex = 0;
      for (const country of countries) {
        countryIndex++;
        if (choosenCountries === "all" || choosenCountries[0] === "all") {
          // Get current country
          const thisCountry = country;

          setAverageLines = this.avgUnitTimeByMonthInCountries[thisCountry];
          // Generate chart data in selected countries
          const numAverage = this.generateDataVisualizationForChart(this.initializeWeeks, setAverageLines, [firstMonth, lastMonth], countryIndex);
          dataVisualization.push({
            seriesname: `${thisCountry === "all" ? "study" : thisCountry}`,
            data: numAverage,
            plottooltext: this.getPlotToolText(true),
            filterType: "country"
          });
          // Get key of sites
          const sites = Object.keys(this.locations[thisCountry]);
          let siteIndex = 0;
          for (const site of sites) {
            siteIndex++;
            // Check if sites exist in list choosenSites
            if (choosenSites.includes(site) || choosenSites[0] === "all" || choosenSites === "all") {
              const siteDataParticipant = this.locations[thisCountry][site];
              numParticipantSites = this.generateDataVisualizationForChart(this.initializeWeeks, siteDataParticipant, [firstMonth, lastMonth], countryIndex + siteIndex);
              dataVisualization.push({
                seriesname: `${site}`,
                data: numParticipantSites,
                filterType: "site",
                plottooltext: this.getPlotToolText(true)
              });
            }
          }
        } else if (choosenCountries.includes(country)) {
          // Check if countries in list choosenCountries or not
          // Get current country
          const thisCountry = country;
          // Get key of sites
          const sites = Object.keys(this.locations[thisCountry]);
          const selectedSiteWithData = sites.filter(site => {
            return choosenSites.includes(site);
          });
          // get average from selected countries
          setAverageLines = this.avgUnitTimeByMonthInCountries[thisCountry];
          // Generate chart data in selected countries
          const numAverage = this.generateDataVisualizationForChart(this.initializeWeeks, setAverageLines, [firstMonth, lastMonth], countryIndex);
          if (selectedSiteWithData.length > 0 || choosenSites[0] === "all" || choosenSites === "all") {
            dataVisualization.push({
              seriesname: `${thisCountry === "all" ? "study" : thisCountry}`,
              data: numAverage,
              filterType: "country",
              plottooltext: this.getPlotToolText(true)
            });
          }
          let siteIndex = 0;
          for (const site of sites) {
            siteIndex++;
            // Check if sites exist in list choosenSites
            if (choosenSites.includes(site) || choosenSites[0] === "all" || choosenSites === "all") {
              const siteDataParticipant = this.locations[thisCountry][site];
              numParticipantSites = this.generateDataVisualizationForChart(this.initializeWeeks, siteDataParticipant, [firstMonth, lastMonth], countryIndex + siteIndex);
              dataVisualization.push({
                seriesname: `${site}`,
                data: numParticipantSites,
                filterType: "site",
                plottooltext: this.getPlotToolText(true)
              });
            }
          }
        }
      }

      dataVisualization = _.orderBy(dataVisualization, [dataForVisualization => dataForVisualization.seriesname.toLowerCase()]);
      if (dataVisualization.length > 0) {
        if (this.enrollTab === "total") {
          dataVisualization = [monthlyAverageArray];
        } else {
          dataVisualization = [monthlyAverageArray].concat(dataVisualization);
        }
        return allAverage.length > 0 ? dataVisualization : [];
      } else {
        return [];
      }
    },
    convertSecondsToMin(){
      //avgUnitTimeByMonthInCountries
      for (let country in this.avgUnitTimeByMonthInCountries) {
        this.avgUnitTimeByMonthInCountries[country].map(data => {
          data.y = data.y / 60;
        });
      }

      //avgUnitTimeByMonthInStudies
      this.avgUnitTimeByMonthInStudies.map(data => {
        data.y = data.y / 60;
        data.ymax = data.ymax / 60;
        data.ymin = data.ymin / 60;
      });

      //locations
      for (let country in this.locations) {
        for (let site in this.locations[country]) {
          this.locations[country][site].map(data => {
            data.y = data.y / 60;
          });
        }
      }

      this.isDataConverted = true;
      this.generateEnrollData();
    }
  }
};
</script>
